var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsOptional, IsUUID } from 'class-validator';
export class CreateAppointmentParticipantDto {
    patientId;
    /**
     * This patient's own Verordnung (#1899): the appointment takes one of its units per
     * billable item. Paired with `billableServiceItemIds`; the plan must be this
     * patient's. Unlike the top-level link, each participant's is checked on its own.
     */
    treatmentPlanId;
    billableServiceItemIds;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAppointmentParticipantDto.prototype, "patientId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAppointmentParticipantDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], CreateAppointmentParticipantDto.prototype, "billableServiceItemIds", void 0);
//# sourceMappingURL=create-appointment-participant.dto.js.map